import { Tab, TabList, TabPanel, Tabs, TabsProps } from 'react-aria-components'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TabsNewProperties = TabsProps & {
    className?: string
    tabListClassName?: string
    tabs: {
        id: string
        name: string
        content: JSX.Element
    }[]
}

export const TabsNew = ({
    className,
    tabListClassName,
    tabs,
    ...properties
}: Readonly<TabsNewProperties>): JSX.Element => {
    return (
        <Tabs
            className={joinStyles(styles.root, className)}
            {...properties}
        >
            {/* Choices */}
            <TabList className={joinStyles(styles.tabsList, tabListClassName)}>
                {tabs.map((tab) => (
                    <Tab
                        key={tab.id}
                        id={tab.id}
                        className={styles.tab}
                    >
                        {tab.name}
                    </Tab>
                ))}
            </TabList>

            {/* Content */}
            {tabs.map((tab) => (
                <TabPanel
                    key={tab.id}
                    id={tab.id}
                    className={styles.tabPanel}
                >
                    {tab.content}
                </TabPanel>
            ))}
        </Tabs>
    )
}
